class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClickHandler.bind(this));

    if (this.dataset.trigger == 'infinite') {
      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  onClickHandler() {
    if (this.classList.contains('loading') || this.classList.contains('disabled')) return;
    this.classList.add('loading');
    this.classList.add('disabled');

    const sections = InfiniteScroll.getSections();
    sections.forEach(() => {
      const url = this.dataset.url;
      InfiniteScroll.renderSectionFromFetch(url);
    });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.onClickHandler();
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  static renderSectionFromFetch(url) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        // Parse once and reuse the same Document across every render step
        // below, instead of each one re-parsing the same HTML string.
        const doc = new DOMParser().parseFromString(responseText, 'text/html');
        InfiniteScroll.renderPagination(doc);
        InfiniteScroll.renderProductGridContainer(doc);

      })
      .catch((e) => {
        console.error(e);
      });
  }

  static renderPagination(doc) {
    // Try multiple selectors to find pagination wrapper
    let container = document.querySelector('#ProductGridContainer .pagination-wrapper');

    // Fallback: Try direct class selector
    if (!container) {
      container = document.querySelector('.pagination-wrapper');
    }

    if (!container) {
      console.warn('⚠️ Pagination wrapper not found anywhere - might be on last page');
      return; // No pagination = last page, no more to load
    }

    const pagination = doc.querySelector('.pagination-wrapper');
    /* Custom code for view item list datalayer event on infinite scroll starts here */
    const collectionData = doc.getElementById('collection-data');
    const collectionProductsData = doc.getElementById('collection-products-data');
    var collectionJson = JSON.parse(collectionData.textContent);
    var CollectionProductsJson = JSON.parse(collectionProductsData.textContent);

    window.dataLayer = window.dataLayer || [];
    var dataType = [];
    CollectionProductsJson.forEach(function (item, index, arr) {
      var data = {};
        data["item_name"] = item.title,
        data["item_id"] = item.id ,
        data["price"] = parseInt(item.price/100),
        data["item_brand"] = item.vendor,
        data["item_category"] = item.type,
        data["item_variant"] = item.variants[0].title,
        data["index"] = parseInt(index+1)
        dataType.push(data);
    });
      
    const newData = {
     item_list_id: collectionJson.id,
     item_list_name: collectionJson.title,
     item_list_url: collectionJson.handle,
     items: [...dataType],
    };
    
    dataLayer.push({
       event: "bvo_view_item_list",
       ecommerce: newData
     });
    /* Custom code for view item list datalayer event on infinite scroll ends here */

    // CRITICAL: Null check before updating pagination
    if (!container) {
      console.warn('⚠️ Pagination container not found - skipping pagination update');
      return;
    }

    if (pagination) {
      container.innerHTML = pagination.innerHTML;
    }
    else {
      container.remove();
    }
  }

  static renderProductGridContainer(doc) {
    const container = document.getElementById('product-grid');
    const products = doc.getElementById('product-grid');
    container.insertAdjacentHTML('beforeend', products.innerHTML);

    // Append Quick View sheets for the newly loaded products (lives outside #product-grid,
    // so it isn't picked up by the block above) so Quick View still opens for them.
    InfiniteScroll.renderQuickViewSheets(doc);
    // Diwali Sale: same for its own quick view panel (#dw-qv-panel)
    InfiniteScroll.renderDiwaliQuickViewSheets(doc);
    // Custom script to sort product cards by availability
    let productGridItems = Array.from(document.querySelectorAll("#product-grid li"))
      .filter(function(item) {
        // Exclude custom sections from sorting (PLP revamp category explore, offer images, etc.)
        return !item.classList.contains('plp-category-explore-section') &&
               !item.hasAttribute('data-custom-section');
      });
    productGridItems.sort(function(a, b) {
      return (parseInt(b.getAttribute('data-index')) < parseInt(a.getAttribute('data-index'))) ? 1 : -1;
    });
    let productGrid = document.querySelector('#product-grid');
    productGridItems.forEach(function(item) {
      productGrid.appendChild(item);
    });
    let imageContainer = document.querySelector('div.collection-offer-image-container');
    let liItem = document.querySelector("#product-grid").querySelectorAll("li")[11];
    // Null check to prevent insertAdjacentElement error
    if (imageContainer && liItem) {
      liItem.insertAdjacentElement('afterend', imageContainer);
    }
    // Custom script to sort product cards by availability ends here
  } 

  static renderQuickViewSheets(doc) {
    const panel = document.getElementById('bs-qv-panel');
    if (!panel) return;

    const fetchedPanel = doc.getElementById('bs-qv-panel');
    if (!fetchedPanel) return;

    const newSheets = fetchedPanel.querySelectorAll('.bs-qv-sheet');
    newSheets.forEach(function (sheet) {
      // Skip sheets already present (e.g. products shown on more than one page)
      if (document.getElementById(sheet.id)) return;
      panel.appendChild(sheet);
    });
  }

  // Diwali Sale: copy of renderQuickViewSheets for #dw-qv-panel / .dw-qv-sheet
  static renderDiwaliQuickViewSheets(doc) {
    const panel = document.getElementById('dw-qv-panel');
    if (!panel) return;

    const fetchedPanel = doc.getElementById('dw-qv-panel');
    if (!fetchedPanel) return;

    fetchedPanel.querySelectorAll('.dw-qv-sheet').forEach(function (sheet) {
      if (document.getElementById(sheet.id)) return;
      panel.appendChild(sheet);
    });
  }
}
customElements.define('infinite-scroll', InfiniteScroll);
